module.exports = __webpack_public_path__ + "images/travel-no-image.9e42c0c8a7bcef8425f2d743b1aba56e.jpg";